import React from "react"
import {FormattedMessage} from "@irati/utils/lang"
import {Label3} from "../../Labels"

interface Props {
  isEnabled: boolean
}

const UserRowDeactivated: React.FC<Props> = ({isEnabled}) => {
  if (isEnabled) {
    return null
  }

  return (
    <Label3>
      <FormattedMessage id="platform.userSearch.deactivated" />
    </Label3>
  )
}

export default UserRowDeactivated
